<template>
  <lab-task
    ><lab-titration
      :variation="variation"
      :conc-naoh="concNaOH"
      :conc-hcl="concHCL"
      :conc-mgoh2="concMgOH2"
      :mass-mgoh2="massMgOH2"
  /></lab-task>
</template>

<script>
import Vue from 'vue';
import LabTitration, {Variation} from '../simulations/LabTitration';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import LabTask from './labs/LabTask';

export default Vue.extend({
  name: 'WindsorTitration',
  components: {LabTitration, LabTask},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      variation: Variation.Windsor,
    };
  },
  computed: {
    concNaOH() {
      return this.taskState.getValueBySymbol('concNaOH').content.toFloat();
    },
    concHCL() {
      return this.taskState.getValueBySymbol('concHCL').content.toFloat();
    },
    concMgOH2() {
      return this.taskState.getValueBySymbol('concMgOH2').content.toFloat();
    },
    massMgOH2() {
      return this.taskState.getValueBySymbol('massMgOH2').content.toFloat();
    },
  },
});
</script>
